import { string, bool } from 'prop-types';
import React, { useState } from 'react';
import { styWrapper, styFlex } from './styles';

function ConfirmationSection({ isInvitation, guestName, codeLink, amount }) {
  const [value, setValue] = useState("");
  const [showResult, setShowResult] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Estado para manejar la carga

  const handleChange = event => {
    let value = event.target.value;
    if (value === "" || (value >= 1 && value <= amount && !isNaN(value))) {
      setValue(value);
    }
  };

  const handleUpdate = () => {
    // crea un objeto con los datos a enviar
    const data = {
      codigoInvitacion: codeLink,
      cantidadConfirmado: value
    };
    
    // Si hay valor, iniciar la carga
    if (value !== "") {
      setIsLoading(true); // Activamos la carga

      fetch(`https://scarletteywaldemar.up.railway.app/api/invitadoPut`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(res => res.json())
        .then(data => {
          setShowResult(true);
          setIsLoading(false); // Desactivamos la carga
        })
        .catch(err => {
          console.error(err, "aaaaaaa");
          setIsLoading(false); // Aseguramos que el estado de carga se desactive en caso de error
        });
    }
  };

  return (
    <div id="fh5co-started" className="fh5co-bg" css={styWrapper}>
      <div className="overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            {!guestName && (
              <h2 className="main-font">{`Gracias...`}</h2>
            )}
            {guestName && (
              <h2 className="main-font">{`¿Desea confirmar, ${guestName}?`}</h2>
            )}
            {isInvitation && (
              <>
                <div className="form-group">
                  {amount === 1 ? (
                    <label htmlFor="exampleInputEmail1"> <strong>invitación para {amount} persona</strong></label>
                  ) : (
                    <label htmlFor="exampleInputEmail1"><strong>invitación para {amount} personas</strong></label>
                  )}
                  <label>Les pedimos que lo realicen antes del <strong>30 de noviembre</strong>, deseamos contar con ustedes en este día tan especial. ¡Esperamos verlos y compartir juntos este momento!</label>
                  <input
                    style={{ marginBottom: "15px" }}
                    type="text"
                    className="form-control"
                    placeholder="Escribe tu nombre"
                  />
                  <input
                    type="text"
                    value={value}
                    onChange={handleChange}
                    min="1"
                    max={amount}
                    className="form-control"
                    placeholder="Número de personas..."
                  />
                </div>
                <button type="submit" onClick={handleUpdate} className="btn btn-primary">
                  Confirmar
                </button>
              </>
            )}
          </div>
          {isLoading && (
            <div className="col-md-5 col-md-offset-5">
              <strong style={{ color: "black" }}>Cargando...</strong> {/* Mensaje de carga */}
            </div>
          )}
          {showResult && !isLoading && (
            <div className="col-md-5 col-md-offset-5">
              <strong style={{ color: "black" }}>¡Has confirmado con éxito!</strong> <br />
            </div>
          )}
        </div>
        {!isInvitation && (
          <div className="row" css={styFlex}>
            <div className="col-md-3">
              <br />
              <br />
              <br />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

ConfirmationSection.propTypes = {
  codeLink: string.isRequired,
  isInvitation: bool.isRequired,
  guestName: string.isRequired,
};

export default React.memo(ConfirmationSection);
